import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
    <style>{`
      @keyframes logoPulse {
        0%   { transform: scale(0.85); opacity: 0; }
        60%  { transform: scale(1.08); opacity: 1; }
        100% { transform: scale(1);    opacity: 1; }
      }
    `}</style>
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-md' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer group" onClick={() => scrollToSection('hero')}>
            <img
              src="https://customer-assets.emergentagent.com/job_wooden-pallets-mx/artifacts/jfcq29mr_logo.png.jpg"
              alt="Zago Pallets Logo"
              className="h-16 w-auto transition-all duration-500 group-hover:scale-110 group-hover:rotate-3 drop-shadow-md"
              style={{ animation: 'logoPulse 2s ease-in-out 1' }}
            />
            <span className={`text-3xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              Zago <span className="text-green-600">Pallets</span>
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className={`font-medium transition-colors ${
                isScrolled 
                  ? 'text-gray-700 hover:text-green-700' 
                  : 'text-white hover:text-green-400'
              }`}
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('servicios')}
              className={`font-medium transition-colors ${
                isScrolled 
                  ? 'text-gray-700 hover:text-green-700' 
                  : 'text-white hover:text-green-400'
              }`}
            >
              Servicios
            </button>
            <button 
              onClick={() => scrollToSection('productos')}
              className={`font-medium transition-colors ${
                isScrolled 
                  ? 'text-gray-700 hover:text-green-700' 
                  : 'text-white hover:text-green-400'
              }`}
            >
              Productos
            </button>
            <button 
              onClick={() => scrollToSection('galeria')}
              className={`font-medium transition-colors ${
                isScrolled 
                  ? 'text-gray-700 hover:text-green-700' 
                  : 'text-white hover:text-green-400'
              }`}
            >
              Galería
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className={`font-medium transition-colors ${
                isScrolled 
                  ? 'text-gray-700 hover:text-green-700' 
                  : 'text-white hover:text-green-400'
              }`}
            >
              Contacto
            </button>
            <Button 
              onClick={() => scrollToSection('contacto')}
              className="bg-green-700 hover:bg-green-800 text-white"
            >
              Cotizar Ahora
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isScrolled 
                ? 'hover:bg-gray-100' 
                : 'hover:bg-white/10'
            }`}
          >
            {isMobileMenuOpen ? (
              <X className={`w-6 h-6 ${isScrolled ? 'text-gray-700' : 'text-white'}`} />
            ) : (
              <Menu className={`w-6 h-6 ${isScrolled ? 'text-gray-700' : 'text-white'}`} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="px-4 py-4 space-y-3">
            <button 
              onClick={() => scrollToSection('hero')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-700 rounded-lg transition-colors"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('servicios')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-700 rounded-lg transition-colors"
            >
              Servicios
            </button>
            <button 
              onClick={() => scrollToSection('productos')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-700 rounded-lg transition-colors"
            >
              Productos
            </button>
            <button 
              onClick={() => scrollToSection('galeria')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-700 rounded-lg transition-colors"
            >
              Galería
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-700 rounded-lg transition-colors"
            >
              Contacto
            </button>
            <Button 
              onClick={() => scrollToSection('contacto')}
              className="w-full bg-green-700 hover:bg-green-800 text-white"
            >
              Cotizar Ahora
            </Button>
          </nav>
        </div>
      )}
    </header>
    </>
  );
};
